import CryptoJS from 'crypto-js/crypto-js'

class AesUtil {
  
    encrypt = (word) => {
        const code = CryptoJS.enc.Utf8.parse('Ier2iij3zeiZaepi'); //16位
        let encrypted = '';
        if (typeof (word) == 'string') {
            encrypted = CryptoJS.AES.encrypt(word, code, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
        } else if (typeof (word) == 'object') { //对象格式的转成json字符串
            let data = JSON.stringify(word);
            let srcs = CryptoJS.enc.Utf8.parse(data);
            encrypted = CryptoJS.AES.encrypt(srcs, code, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            })
        }
        return encrypted.toString();
    }

    decrypt = (word) => {
        var encryptedData = word.ciphertext.toString();

        var encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedData);
        var encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);

        var decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        var decryptedStr = decryptedData.toString(CryptoJS.enc.Utf8);
        return decryptedStr

    }

    showConsole = () => {
        const wordText = "123456";
        const jiami = this.encrypt(wordText);
        console.log(jiami);
        console.log(this.decrypt(jiami));

    }


}

export default AesUtil

